/* Open the product gallery on the selected color's photo (links from ads, TikTok and Google include ?variant=) */
(() => {
  const jump = () => {
    document.querySelectorAll('[data-product]').forEach((root) => {
      const json = root.querySelector('[data-product-json]');
      const input = root.querySelector('[data-variant-id]');
      const slides = root.querySelector('[data-gallery-slides]');
      if (!json || !input || !slides) return;
      let product; try { product = JSON.parse(json.textContent); } catch (e) { return; }
      const v = product.variants.find((x) => String(x.id) === String(input.value));
      if (!v || !v.featured_media) return;
      const slide = root.querySelector('[data-media-id="' + v.featured_media.id + '"]');
      if (slide) slides.scrollTo({ left: slide.offsetLeft - slides.offsetLeft, behavior: 'auto' });
    });
  };
  if (document.readyState === 'complete') jump(); else window.addEventListener('load', jump);
})();
